import { createQuery } from "@/shared/helpers/create-query.helper";
import { UserListResponse } from "@/shared/models/interfaces/response/users/user-list-response.interface";
import { UserListValuesQRTK } from "./values/user-list.values";
import { UsersEndpoints } from "../../endpoints/users.endpoint";
import { CheckIdentificationUserQRTK } from "./values/check-identification-user.values";
import { CheckEmailUserQRTK } from "./values/check-email-user.values";
import { transformResponseListUser } from "./responses/get-users.response";
import {
  AgentsPlansResponseSchema,
  transformResponseAgentsPlans
} from "./responses/get-agents-plans.response";
import { mainSplitApi } from "../../mainSplitApi";
import {
  IUserHistoryChangesRTKQ,
  IUserHistoryResponses
} from "./values/user-history-changes.values";
import { SendOtpUserQRTK } from "./values/send-otp.values";
import { I_CurrentUserResponse } from "@/shared/services/qrtk/auth/model/responses/current-user";
import { LoginAsQRTK } from "./values/login-as.values";
import USERS_TAG_TYPES from "./users.tags";
import getFormData from "@/src-refactor/modules/shared/helpers/object-to-form-data";

export const UsersQueryServices = mainSplitApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    getListUser: mutation({
      query: (values: UserListValuesQRTK) => {
        return {
          url: UsersEndpoints.UsersList,
          method: "GET",
          params: values.query
        };
      },
      transformResponse: (response: UserListResponse, meta, arg) => response
    }),
    getUserHistoryChanges: query<IUserHistoryResponses, IUserHistoryChangesRTKQ>({
      query: values => ({
        url: UsersEndpoints.historyChanges(values.params.id),
        method: "GET"
      }),
      transformResponse: response => response as IUserHistoryResponses
    }),
    checkIdentificationUser: mutation({
      query: (values: CheckIdentificationUserQRTK) => ({
        url: UsersEndpoints.CheckIdentification,
        method: "GET",
        params: values?.query
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => {
        return baseQueryReturnValue.data;
      },
      transformResponse: response => response
    }),
    checkEmailUser: mutation({
      query: (values: CheckEmailUserQRTK) => ({
        url: UsersEndpoints.CheckEmail + createQuery(values.query)
      }),
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return baseQueryReturnValue.data;
      },
      transformResponse: (response, meta, arg) => {
        return response;
      }
    }),

    getAgents: query<any, UserListValuesQRTK>({
      query: values => ({
        url: UsersEndpoints.UsersList,
        params: values.query,
        method: "GET"
      }),
      transformResponse: response => transformResponseListUser(response as any)
    }),
    getAgentsPlans: query<AgentsPlansResponseSchema, void>({
      query: () => ({
        url: UsersEndpoints.UsersPlans,
        method: "GET"
      }),
      transformResponse: response =>
        transformResponseAgentsPlans(response as AgentsPlansResponseSchema)
    }),
    sendOtp: mutation({
      query: (values: SendOtpUserQRTK) => ({
        url: UsersEndpoints.SendOTP,
        method: "GET"
        // body: values
      }),
      transformResponse: response => response
    }),

    getCurrentUser: query({
      query: (values: any | null) => ({
        url: UsersEndpoints.GetCurrentUser,
        method: "GET"
      }),

      transformResponse: (response: I_CurrentUserResponse, meta, arg) =>
        response.data,
      providesTags: [USERS_TAG_TYPES.CURRENT_USER]
    }),

    loginAs: mutation({
      query: (values: LoginAsQRTK) => ({
        url: UsersEndpoints.LoginAs,
        method: "POST",
        body: getFormData(values.body)
      }),
      invalidatesTags: [USERS_TAG_TYPES.CURRENT_USER]
    })
  })
});

export const {
  useCheckEmailUserMutation,
  useGetAgentsQuery,
  useLazyGetAgentsQuery,
  useGetAgentsPlansQuery,
  useLazyGetAgentsPlansQuery,
  useGetListUserMutation,
  useCheckIdentificationUserMutation,
  useGetUserHistoryChangesQuery,
  useSendOtpMutation,
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useLoginAsMutation
} = UsersQueryServices;
